import React, { useState } from "react";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import ExpandMore from "@mui/icons-material/ExpandMore";
import * as S from "./styles";

interface IKogPaginationShowMoreProps<T> {
	dataList: T[] | null;
	maxShow?: number;
	render: (data: T) => JSX.Element;
	renderFinalList?: JSX.Element;
}
function KogPaginationShowMore<T>({ dataList, maxShow = 5, renderFinalList, render }: IKogPaginationShowMoreProps<T>) {
	const [maxShowState, setMaxShowState] = useState(maxShow);

	function handleShowMore(e: React.MouseEvent<HTMLButtonElement>) {
		e.preventDefault();
		setMaxShowState((prev) => prev + maxShow);
	}

	if (isNullUndefined(dataList)) return <></>;

	const dataListSlice = dataList.slice(0, maxShowState);
	const hasManyItems = dataList.length >= maxShow;
	const hasShowEverything = maxShowState > dataList.length;

	return (
		<S.Container>
			<S.Content>
				{dataListSlice.map((item) => render(item))}
				{hasShowEverything && renderFinalList}
			</S.Content>
			<S.AreaShowMore>
				{hasManyItems && !hasShowEverything && (
					<S.ButtonShowMore id="id-kog-pagination-show-more" onClick={handleShowMore}>
						<span>
							{getTranslateByKey("information.showMore")}
							<ExpandMore color="primary" aria-expanded={true} aria-label={getTranslateByKey("information.showMore")} />
						</span>
					</S.ButtonShowMore>
				)}
			</S.AreaShowMore>
		</S.Container>
	);
}

export default KogPaginationShowMore;
